import { Link } from 'react-router-dom';

const Header = (): React.JSX.Element => {
   return (
      <header className="md-header md-header--shadow">
         <nav className="md-header-nav md-grid" aria-label="Header">
            <Link to="/" className="md-header-nav__button md-logo" aria-label="Apo-Holo Juxtaposition">
               <svg viewBox="0 0 89 89" xmlns="http://www.w3.org/2000/svg">
                  <path d="M 3.136 72.399 L 3.136 29.467 L 46.068 8 L 3.136 72.399 Z" />
                  <path
                     d="M 21.91 81.786 L 64.843 17.388 L 46.068 8 L 3.136 72.399 L 21.91 81.786 Z"
                     fillOpacity=".5"
                  />
                  <path d="M 67.535 72.399 L 40.273 54.243 L 62.151 21.425 L 67.535 18.734 L 67.535 72.399 Z" />
                  <path
                     d="M 67.535 72.399 L 67.535 18.733 L 86.309 28.121 L 86.309 81.786 L 67.535 72.399 Z"
                     fillOpacity=".25"
                  />
               </svg>
            </Link>
            <div className="md-header-nav__title">
               <div className="md-header-nav__ellipsis">
                  <div className="md-header-nav__topic">
                     <span className="md-ellipsis">AHoJ: Apo-Holo Juxtaposition</span>
                  </div>
               </div>
            </div>
            <div className="md-header-nav">
               <nav className="md-tabs md-tabs--hidden" aria-label="Tabs">
                  <div className="md-tabs__inner md-grid">
                     <ul className="md-tabs__list">
                        <li className="md-tabs__item">
                           <Link to="/db" className="md-tabs__link">
                              AHoJ-DB
                           </Link>
                        </li>
                        <li className="md-tabs__item">
                           <Link
                              to="/db/seqsim"
                              className="md-tabs__link"
                              title="Search AHoJ-DB by UniProt sequence similarity"
                           >
                              Seq Search
                           </Link>
                        </li>
                        <li className="md-tabs__item">
                           <Link to="/" className="md-tabs__link">
                              AHoJ
                           </Link>
                        </li>
                        <li className="md-tabs__item">
                           <Link to="/help" className="md-tabs__link">
                              Help
                           </Link>
                        </li>
                        <li className="md-tabs__item">
                           <Link to="/about" className="md-tabs__link">
                              About
                           </Link>
                        </li>
                     </ul>
                  </div>
               </nav>
            </div>

            <div className="md-header-nav__source">
               <a href="https://github.com/cusbg/AHoJ-project" className="md-source" target="_blank">
                  <div className="md-source__icon md-icon">
                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path d="M439.55 236.05L244 40.45a28.87 28.87 0 00-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 01-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 000 40.81l195.61 195.6a28.86 28.86 0 0040.8 0l194.69-194.69a28.86 28.86 0 000-40.81z" />
                     </svg>
                  </div>
                  <div className="md-source__repository">GitHub</div>
               </a>
            </div>
         </nav>
      </header>
   );
};

export default Header;
